import { Card, CardContent, CardHeader, CardTitle } from '@sunstone/ui';
import { PageHeader } from '@/components/ui/PageHeader';

export function SettingsPage() {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <PageHeader
        title="Settings"
        description="Configure integrations, notifications, and application-level settings."
      />

      <Card>
        <CardHeader>
          <CardTitle>General</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Settings configuration coming soon.</p>
        </CardContent>
      </Card>
    </div>
  );
}
